import { FormattedShopifyProduct } from '@portal/types/shopify/product.formatted.types';

/* ---- getters ------ */

export const getNumberOfFreeProducts = (products: FormattedShopifyProduct[]) => {
  return products.filter((product) => Number(product.variants[0].price.amount) === 0).length;
};

export const getNonMembersOnlyProducts = (products: FormattedShopifyProduct[]) => {
  return products.filter(
    (product) =>
      !product.metafields.find(
        (metafield) =>
          metafield && metafield.namespace === 'custom' && metafield.key === 'members_only'
      ) ||
      product.metafields.find(
        (metafield) =>
          metafield &&
          metafield.namespace === 'custom' &&
          metafield.key === 'members_only' &&
          metafield.value !== 'true'
      )
  );
};

export const getFilteredProducts = (
  products: FormattedShopifyProduct[],
  options: { categorySlug: string; isLoggedIn: boolean }
) => {
  const shopifyCategoryMetaKey = options.categorySlug.replace('-', '_');
  const filteredProducts = products.filter((productData) =>
    productData.metafields.find(
      (metafield) =>
        metafield &&
        metafield.namespace === 'custom' &&
        metafield.key === shopifyCategoryMetaKey &&
        metafield.value === 'true'
    )
  );

  return options.isLoggedIn ? filteredProducts : getNonMembersOnlyProducts(filteredProducts);
};
